import { constants as config } from '@config';
import tinycolor from 'tinycolor2';

import { backwardsCompatibility } from '../editor/video';

// TODO:
// Here are main converter is in ext-layout: setLayout
// For text is in ext-texarea: fixOldTextArea
export default function converterCurrentPage () {
  let isPlugin = false;

  // For backward compatibility
  function convertOldTextsToNew (textarea) {
    // set default font
    if (!textarea.getAttribute('font-family')) textarea.setAttribute('font-family', 'Lato');
    textarea.getAttribute('font-size') || textarea.setAttribute('font-size', '22');
    const rect = textarea.querySelector('rect:not(.highlight-rect)');
    rect.removeAttribute('style');
    rect.removeAttribute('stroke');

    const groupTexts = Array.from(textarea.querySelectorAll('g.textGroup'));
    groupTexts.forEach(groupText => {
      groupText.classList.remove('textGroup');
      groupText.classList.add('text');
    });

    // check bboxes
    textarea.querySelectorAll('tspan:empty, text:empty')
      .forEach(element => { element.textContent = '\u00A0'; });

    textarea.querySelectorAll(':scope > text')
      .forEach(element => element.removeAttribute('id'));

    svgedit.transformlist.removeElementFromListMap(textarea);
    const tlist = svgedit.transformlist.getTransformList(textarea);
    if (!tlist) return;

    let prevListSize;
    let currentListSize = tlist.numberOfItems;

    while (currentListSize > 0 && currentListSize !== prevListSize) {
      svgedit.transformlist.removeElementFromListMap(textarea);
      svgedit.recalculate.recalculateDimensions(textarea);

      prevListSize = currentListSize;
      currentListSize = svgedit.transformlist.getTransformList(textarea).numberOfItems;
    }
  }

  // Get dx from x[]
  function convertXArrayToDx (textarea) {
    const groupText = textarea.querySelector('g.text');

    for (let c = 0; c < groupText.classList.length; c++) {
      if (groupText.classList[c].match(/ line-margin-.+/)) {
        return;
      }
    }

    const isRTL = groupText.getAttribute('direction') === 'rtl';

    const rectElement = textarea.querySelector('rect');
    const baseWidth = parseFloat(rectElement.getAttribute('width'));
    const isTableText = textarea.parentElement && textarea.parentElement.classList.contains('table-cell');
    let basePositionX = parseFloat(rectElement.getAttribute('x'));
    if (isRTL) {
      basePositionX += baseWidth;
    }

    textarea.querySelectorAll('text').forEach(textElement => {
      const stringAnchor = textElement.getAttribute('text-anchor');
      if (stringAnchor && stringAnchor !== 'start') return;
      if (textElement.hasAttribute('dx')) return;

      const positionX = textElement.getAttribute('x');
      const mainAnchor = stringAnchor || textarea.querySelector('g.text').getAttribute('text-anchor');

      if (!positionX) {
        return;
      }

      textElement.setAttribute('x', basePositionX);

      let dx;
      // Is x an array (represented as string)
      if (positionX.indexOf(' ') !== -1) {
        const positionXArray = positionX.split(' ');
        isPlugin = true;
        // Position values must be defined for each character
        if (!textElement.textContent.length || positionXArray.length < textElement.textContent.length) {
          return;
        }

        dx = isRTL ? [basePositionX - positionXArray[0]] : [positionXArray[0] - basePositionX];
        for (let i = 0; i < textElement.textContent.length - 1; i++) {
          const dxValue = isRTL
            ? positionXArray[i] - positionXArray[i + 1] - textElement.getExtentOfChar(i).width
            : positionXArray[i + 1] - positionXArray[i] - textElement.getExtentOfChar(i).width;

          dx.push(dxValue);
        }
      } else if (isTableText && mainAnchor === 'start') {
        dx = [Number(positionX) - Number(basePositionX)];
      } else { // x is an scalar
        return;
      }

      if (dx && dx.length) {
        dx = dx.map(d => Math.abs(d) < 0.1 ? 0 : d.toFixed(2));
        const textAttributes = getGroupTextAttributes(groupText);
        if ((textAttributes.hasLineMargin && textAttributes.hasColumn) || groupText.hasAttribute('data-margin')) dx[0] = 0;

        const bullet = textElement.querySelector('.bullets');
        const order = textElement.querySelector('.ordered');

        const orderedLength = bullet?.textContent.length || order?.textContent.length || 0;

        if (orderedLength && dx.length > 1) {
          for (let i = 1; i <= orderedLength; i++) {
            dx[i] = 0;
          }
        }

        textElement.setAttribute('dx', dx.join(' '));
      }
    });
    isPlugin && !isTableText && rectElement.setAttribute('width', baseWidth);
  }

  function getGroupTextAttributes (groupText) {
    const attributes = {
      hasColumn: false,
      hasLineSpacing: false,
      hasLineMargin: false,
      hasParagraphSpacing: false
    };

    for (let c = 0; c < groupText.classList.length; c++) {
      const classList = groupText.classList[c];
      if (classList.match(/line-spacing-.+/)) {
        attributes.hasLineSpacing = true;
      } else if (classList.match(/columns-.+/)) {
        attributes.hasColumn = true;
      } else if (classList.match(/ line-margin-.+/)) {
        attributes.hasLineMargin = true;
      } else if (classList.match(/paragraph-spacing-.+/)) {
        attributes.hasParagraphSpacing = true;
      } else if (classList.match(/first-line-margin-.+/)) {
        attributes.hasFirstLineMargin = true;
      }
    }

    return attributes;
  }

  // Get margin from dx[0]
  function convertDxtoMargin (textarea) {
    const parent = textarea.parentElement;
    if (parent && parent.classList.contains('table-cell')) return;

    const groupText = textarea.querySelector('g.text');
    if (groupText.getAttribute('text-anchor') !== 'start' || groupText.hasAttribute('data-margin')) {
      return;
    }

    for (let c = 0; c < groupText.classList.length; c++) {
      if (groupText.classList[c].match(/ line-margin-.+/)) {
        return;
      }
    }

    const dataMargin = [];
    const texts = textarea.querySelectorAll('text');
    const hasDx = textarea.querySelectorAll('text[dx]');
    if (!hasDx.length) return;

    let newLine = true;
    texts.forEach(textElement => {
      if (newLine) {
        let marginAdded = false;
        const dxString = textElement.getAttribute('dx');
        if (dxString) {
          const dx = dxString.split(' ');
          if (dx[0] > 0) {
            dataMargin.push(dx[0]);
            marginAdded = true;
            dx[0] = 0;
            textElement.setAttribute('dx', dx.join(' '));
          }
        }

        if (!marginAdded) {
          dataMargin.push(0);
        }
      }
      newLine = textElement.classList.contains('eol');
    });

    // Add margin
    const nonZeroExists = dataMargin.some(m => m !== 0);
    const allEqual = nonZeroExists && dataMargin.every(m => m === dataMargin[0]);
    const firstMargin = dataMargin[0];
    const firstMarginAsInteger = Math.floor(firstMargin);
    if (allEqual && Math.abs(firstMarginAsInteger - firstMargin) < 0.1) {
      groupText.classList.add(`line-margin-${firstMarginAsInteger}`);
      return;
    }

    nonZeroExists && groupText.setAttribute('data-margin', dataMargin.join(' '));
  }

  function addDataParagraphDy (textarea) {
    const groupText = textarea.querySelector('g.text');
    const texts = textarea.querySelectorAll('text');

    // Ignore if data-paragraph-dy is already defined.
    if (groupText.hasAttribute('data-paragraph-dy') || texts.length < 2) return;

    const textAttributes = getGroupTextAttributes(groupText);
    if (!groupText.hasAttribute('data-dy') && !textAttributes.hasLineSpacing) return;
    if (textAttributes.hasParagraphSpacing || textAttributes.hasColumn) return;

    const rect = textarea.querySelector('rect');
    if (!rect) return;

    const dataDy = [];
    const rectY = parseFloat(rect.getAttribute('y'));
    let previousPositionY = (texts[0] && parseFloat(texts[0].getAttribute('y'))) || rectY;
    let isPreviousPositionDetected = false;

    for (let i = 0; i < texts.length; i++) {
      const textElement = texts[i];

      const isEol = textElement.classList.contains('eol');
      const fontSize = parseFloat(getComputedStyle(textElement).fontSize);

      if (!isEol) return;

      if (!isPreviousPositionDetected && isEol) {
        previousPositionY = parseFloat(textElement.getAttribute('y'));
        isPreviousPositionDetected = true;
      }

      if (isEol && texts[i + 1]) {
        const positionY = parseFloat(texts[i + 1].getAttribute('y'));
        const dy = positionY - previousPositionY - fontSize;
        dataDy.push(dy.toFixed(2));
        previousPositionY = positionY;
      } else if (isEol) {
        dataDy.push(0);
      }
    }

    const largeValuesFound = dataDy.some(dy => Math.abs(dy) > 1);
    largeValuesFound && groupText.setAttribute('data-paragraph-dy', dataDy.join(' '));
    groupText.removeAttribute('data-dy');
  }

  // Make sure this textarea object has optimized partial styling
  function cleanRedundantTextStyles (textarea) {
    if (!isPlugin) return;

    removeUnsupportedTableTextStyles(textarea);

    if (textarea.textContent && textarea.textContent.length <= 100) return;
    cleanRedundantPartialStyling(textarea, 'font-weight', 'string', 'normal');
    cleanRedundantPartialStyling(textarea, 'font-size', 'number', null);
    cleanRedundantPartialStyling(textarea, 'font-family', 'string', null);
    cleanRedundantPartialStyling(textarea, 'fill', 'string', null);
  }

  function convertLostShapesToElement (element) {
    element.classList.add('element');
  }

  function removeUnsupportedTableTextStyles (textarea) {
    // Remove styles that are not supported by table
    // For the next updates, this clearing phase will be removed
    // as we will support most styles like text-decoration.

    const parent = textarea.parentElement;
    if (parent && parent.classList.contains('table-cell')) return;

    const elements = textarea.querySelectorAll('[text-decoration]');
    elements.forEach(element => element.removeAttribute('text-decoration'));
  }

  function recalculateBlankLine (textarea) {
    const texts = textarea.querySelectorAll('text');
    for (let i = 0; i < texts.length; i++) {
      const textElement = texts[i];
      const isEol = textElement.classList.contains('eol');
      if (!isEol) continue;

      let isBlank = textElement.classList.contains('blank');
      const content = textElement.textContent;

      const lastLine = i > 0 && texts[i - 1];
      const isLastLineEol = lastLine && lastLine.classList.contains('eol');

      if (!isBlank && content === config.text.noBreakSpace && isLastLineEol) {
        isBlank = true;
        textElement.classList.add('blank');
      }

      if (!isBlank) continue;

      const span = textElement.querySelector('tspan:not(.bullets):not(.ordered)');
      if (span) {
        span.textContent = config.text.noBreakSpace;
      } else {
        textElement.innerHTML = config.text.noBreakSpace;
      }
    }
  }

  function addSpaceToEachLine (textarea) {
    const texts = Array.from(textarea.querySelectorAll('text:not(.blank):not(.eol)'));
    for (const text of texts) {
      if (text.textContent.split(/\s/).length <= 1) continue;
      const match = text.textContent.match(/\s+$/i);
      if (match) continue;
      console.warn('[addSpaceToEachLine]: Something wrong with Import File. Adding space to the end of the line', text.textContent);
      const spans = text.querySelectorAll('tspan:not(.bullets):not(.ordered)');
      const span = spans.length && spans[spans.length - 1];
      if (span) {
        span.textContent += config.text.noBreakSpace;
      } else {
        text.textContent += config.text.noBreakSpace;
      }
    }
  }

  const content = document.getElementById('svgcontent');
  const lostShapes = content.querySelectorAll('.main > *[id]:not(.element)');
  const textAreas = [...content.querySelectorAll('.main g.textarea')].filter(element => !element.closest('.table-cell'));
  const videos = content.querySelectorAll('.element.video, .element.video-elem');

  // Convert old text to the new
  textAreas.forEach(convertOldTextsToNew);

  textAreas.forEach(addSpaceToEachLine);

  // Convert x array to dx
  textAreas.forEach(convertXArrayToDx);

  // Optimize partial styling
  textAreas.forEach(cleanRedundantTextStyles);

  // Convert dx[0] to margin
  textAreas.forEach(convertDxtoMargin);

  // Add data-dy if lines are not in the expected position
  textAreas.forEach(addDataParagraphDy);

  textAreas.forEach(recalculateBlankLine);

  // Convert old videos to new videos
  videos.forEach(backwardsCompatibility);

  // add element class for elements in the root canvas without element class
  lostShapes.forEach(convertLostShapesToElement);

  // Converts SVG styles to inline attributes:
  processSvgStyles(content);

  INKIVE.Text._cache = {};

  const editor = INKIVE.Tool.getInstance().editor;

  for (const textareaElement of textAreas) {
    const isTableText = textareaElement?.parentElement?.classList?.contains('table-cell');
    if (isTableText) continue;

    const textArea = new INKIVE.Text.Textarea().setDOM(textareaElement, false);
    editor.canvas.runExtensions('renderTextArea', { textArea, resize: false, isCursor: false });
  }
}

// Optimize attribute definition for text while keeping its initial appearance as it is
export function cleanRedundantPartialStyling (textarea, attributeName, type, defaultValue) {
  const groupText = textarea.querySelector('g.text');
  const globalValue = getValue(groupText, attributeName, type, defaultValue);
  const valueFrequency = getValueFrequency(textarea, globalValue, attributeName, type, defaultValue);

  textarea.querySelectorAll('text').forEach(textElement => {
    const tspans = textElement.querySelectorAll('tspan');
    if (tspans.length === 0) {
      valueFrequency[globalValue] = valueFrequency[globalValue]
        ? valueFrequency[globalValue] + 1
        : 1;
    }
    tspans.forEach(tspan => {
      if (tspan.hasAttribute(attributeName)) {
        const value = getValue(tspan, attributeName, type, defaultValue);
        if (!value) return;

        valueFrequency[value] = valueFrequency[value]
          ? valueFrequency[value] + 1
          : 1;
      } else {
        valueFrequency[globalValue] = valueFrequency[globalValue]
          ? valueFrequency[globalValue] + 1
          : 1;
      }
    });
  });

  // Find value with the highest usage frequency
  let selectedValue = null;
  let selectedValueFrequency = -1;
  for (const value in valueFrequency) {
    if (valueFrequency[value] > selectedValueFrequency) {
      selectedValueFrequency = valueFrequency[value];
      selectedValue = value;
    }
  }

  if (!selectedValue || selectedValue === defaultValue) return;

  // If attribute value is expected to be a number, make sure we have it so
  // otherwise comparison expressions will not work
  if (type === 'number') selectedValue = Number(selectedValue);

  const globalValueChanged = selectedValue !== globalValue;

  groupText.setAttribute(attributeName, selectedValue);

  textarea.querySelectorAll('text').forEach(textElement => {
    const tspans = textElement.querySelectorAll('tspan');
    if (tspans.length) {
      tspans.forEach(tspan => {
        if (tspan.hasAttribute(attributeName)) {
          const value = getValue(tspan, attributeName, type, defaultValue);
          value === selectedValue && tspan.removeAttribute(attributeName);
        } else {
          globalValueChanged && tspan.setAttribute(attributeName, globalValue);
        }
      });
    } else if (globalValueChanged) {
      textElement.innerHTML = `<tspan ${attributeName}="${globalValue}">${textElement.textContent}</tspan>`;
    }
  });
}

function getValueFrequency (textarea, globalValue, attributeName, type, defaultValue) {
  const valueFrequency = {};
  textarea.querySelectorAll('text').forEach(textElement => {
    const tspans = textElement.querySelectorAll('tspan');
    if (tspans.length === 0) {
      valueFrequency[globalValue] = valueFrequency[globalValue]
        ? valueFrequency[globalValue] + 1
        : 1;
    }
    tspans.forEach(tspan => {
      if (tspan.hasAttribute(attributeName)) {
        const value = getValue(tspan, attributeName, type, defaultValue);
        if (!value) return;

        valueFrequency[value] = valueFrequency[value]
          ? valueFrequency[value] + 1
          : 1;
      } else {
        valueFrequency[globalValue] = valueFrequency[globalValue]
          ? valueFrequency[globalValue] + 1
          : 1;
      }
    });
  });
  return valueFrequency;
}

function getValue (element, attributeName, type, defaultValue) {
  let value = defaultValue;
  switch (type) {
    case 'number':
      value = element.hasAttribute(attributeName)
        ? parseFloat(element.getAttribute(attributeName))
        : defaultValue;
      break;
    case 'string':
      value = element.getAttribute(attributeName) || defaultValue;
      if (value) value = value.replace(/[']/g, '');
      break;
    default:
      break;
  }
  return value;
}

/**
 * Converts SVG styles to inline attributes:
 *
 * 1. Parses all `<style>` tags in the SVG and extracts CSS rules.
 * 2. Applies matching styles as inline attributes (e.g., `fill`, `stroke`) to elements with `cls-*` classes.
 * 3. Cleans up by removing `cls-*` classes and `<style>` tags for a self-contained SVG.
 *
 * This ensures consistent rendering and portability of the SVG across environments.
 *
 * @param {HTMLElement} svgContainer - The SVG container element to process.
 */
function processSvgStyles (svgContainer) {
  try {
    const elements = svgContainer.querySelectorAll('.element');
    const styleTags = Array.from(svgContainer.querySelectorAll('style'));

    if (!styleTags.length) return;

    const styleRules = parseAllStyleTags(styleTags);

    elements.forEach(element => {
      const convertList = Array.from(element.querySelectorAll('[class^="cls-"], [class^="st"]'));
      if (!convertList.length) return;

      applyStylesToElements(convertList, styleRules);
      cleanUpElementStyles(convertList);
    });

    removeStyleTags(styleTags);
  } catch (error) {
    console.error('Error processing SVG styles:', error);
  }

  function parseAllStyleTags (styleTags) {
    return styleTags.flatMap(styleTag => {
      return styleTag.textContent
        .split('}')
        .filter(rule => rule.trim())
        .map(rule => {
          const [selector, declarations] = rule.split('{').map(part => part.trim());
          return { selector, declarations };
        });
    });
  }

  function applyStylesToElements (elements, styleRules) {
    elements.forEach(clsElement => {
      styleRules.forEach(({ selector, declarations }) => {
        if (clsElement.matches(selector)) {
          declarations.split(';').forEach(declaration => {
            const [property, value] = declaration.split(':').map(part => part.trim());
            if (property && value) {
              if (['fill', 'stroke'].includes(property)) {
                clsElement.setAttribute(property, tinycolor(value).toHexString());
              }
            }
          });
        }
      });
    });
  }

  function cleanUpElementStyles (elements) {
    elements.forEach(clsElement => {
      Array.from(clsElement.classList).forEach(cls => {
        if (cls.startsWith('cls-') || cls.startsWith('st')) {
          clsElement.classList.remove(cls);
        }
      });
    });
  }

  function removeStyleTags (styleTags) {
    styleTags.forEach(styleTag => styleTag.remove());
  }
}
